export default () => {
  const items = document.querySelectorAll('.projects__item');

  items.forEach((item) => {
    const link = item.querySelector('.projects__link');
    const inner = item.querySelector('.projects__item-inner');
    let animating = false;

    async function toggle() {

      item.style.maxHeight = `${inner.offsetHeight}px`;

      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            item.classList.toggle('expanded');
            setTimeout(() => {
              item.style.maxHeight = null;
              resolve();
            }, item.classList.contains('expanded') ? 350 : 0);
          });
        });
      });
    }

    link.addEventListener('click', async (event) => {
      event.preventDefault();
      if (animating) return;
      animating = true;

      await toggle();

      animating = false;
    });
  });
};
